import { Checkbox } from "@/components/atoms/CheckBox";
import { getYearFromDate } from "@/lib/utils";

interface YearsSetterProps {
  title: string;
  possibleYears: Date[];
  years: Date[];
  setYears: (years: Date[]) => void;
}

const byYear = (year0: Date, year1: Date) =>
  getYearFromDate(year0).localeCompare(getYearFromDate(year1));

const YearSetter = ({
  title,
  possibleYears,
  setYears,
  years,
}: YearsSetterProps) => {
  return (
    <div className="flex flex-col gap-2">
      <span>{title}</span>
      <div className="grid grid-cols-3 gap-4">
        {possibleYears.sort(byYear).map((year) => {
          const label = getYearFromDate(year);
          const id = `${title}-${label}`;
          const checked = years.some((y) => getYearFromDate(y) === label);

          return (
            <div className="flex flex-row gap-2 items-center" key={id}>
              <Checkbox
                checked={checked}
                onClick={() =>
                  setYears(
                    (checked
                      ? years.filter((y) => getYearFromDate(y) !== label)
                      : [...years, year]
                    ).sort(byYear),
                  )
                }
                id={id}
              />
              <label htmlFor={id}>{label}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YearSetter;
